module.exports = __webpack_public_path__ + "static/media/SF_nn_engl_sekundaerlogo_postale_vestfold_telemark_neg.4cc3d8c3.svg";